import { render } from "./caliber.vue?vue&type=template&id=0c2487ba&scoped=true"
import script from "./caliber.vue?vue&type=script&lang=js"
export * from "./caliber.vue?vue&type=script&lang=js"

import "./caliber.vue?vue&type=style&index=0&id=0c2487ba&lang=less&scoped=true"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2487ba"]])

export default __exports__